document.addEventListener('DOMContentLoaded', function () {
    var blogContent = document.getElementById('blog_content');
    if (!blogContent) return;

    blogContent.querySelectorAll('*').forEach(function (el) {
        if (el.style.fontFamily) {
            el.style.removeProperty('font-family');
        }
        if (el.style.lineHeight) {
            el.style.lineHeight = '1.5';
        }
    });
});

// Table of Contents: the list and the reading time are rendered on the server (fixHeadings
// headingToc), so the box is in the first paint; built here after load it pushed the post down
// (mobile CLS 0.09-0.20). Only the smooth scroll lives here.
(function() {
    var tocList = document.getElementById('toc-list');
    if (!tocList) return;
    tocList.addEventListener('click', function(e) {
        var link = e.target.closest('a[data-target]');
        if (!link) return;
        e.preventDefault();
        e.stopPropagation();
        var target = document.getElementById(link.getAttribute('data-target'));
        if (target) {
            var offset = window.innerWidth <= 768 ? 65 : 90;
            var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top: targetPosition, behavior: 'smooth' });
        }
    }, true);
})();
